import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { buildUriForCall } from '@/helpers/functions/buildUri'
import { Message } from 'element-ui'
import { fakeUrl } from '@/helpers/functions/fakeDataStats'

export default {
  namespaced: true,
  state: {
    loadingLinkedin: false,
    filters: {
      start: 0,
      count: 10
    },
    total: 0,
    statistics: {},
    graphStats: {},
    posts: {}
  },
  getters: {
    getStatisticsLinkedin: (state) => state.statistics,
    getLoadingLinkedin: (state) => state.loadingLinkedin,
    getPostsLinkedin: (state) => state.posts,
    getGraphStatsLinkedin: (state) => state.graphStats,
    getTotal: (state) => state.total
  },
  mutations: {
    setLoadingLinkedin (state, bool) {
      state.loadingLinkedin = bool
    },
    setStatistics (state, data) {
      state.statistics = data
    },
    setGraphStats (state, data) {
      state.graphStats = data
    },
    setPosts (state, data) {
      state.posts = data
    },
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setTotal (state, total) {
      state.total = total
    }
  },
  actions: {
    loadStatisticsLinkedin ({ state, commit }) {
      commit('setLoadingLinkedin', true)

      const path = fakeUrl('/linkedin/statistics', '/fake/statistics/linkedin')

      const filters = { start: state.filters.start, count: state.filters.count }
      const url = buildUriForCall(path, filters)

      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then((response) => {
          commit('setGraphStats', response.data.graphStats)
          commit('setStatistics', response.data.statistics)
          commit('setPosts', response.data.posts)
          commit('setTotal', response.data.posts.paging.total)
        }).catch(() => {
          Message.error('Une erreur est survenue lors du chargement des données.')
        }).finally(() => {
          commit('setLoadingLinkedin', false)
        })
    }
  }
}
